import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
export const MandateURL = {
    mfMandate: (userId) => {
        return config.jmw + config.jmw_mf + "bank/" + userId + "/mandate";
    },
    mfBankDetails: (userId) => {
        return config.jmw + config.jmw_mf + "bank/" + userId + "/details";
    },
    mandateCalendar: (userId, mandateId) => {
        return (config.jmw + config.jmw_mf + "mandatecalendar/" + userId + "/mandateId/" + mandateId);
    },
    emandateUrl: (userId) => {
        return config.jmw + config.jmw_mf + "bank/" + userId + "/emandate";
    },
    uploadMandateImage: config.jmw + config.jmw_mf + "upload/scanmandateimage",
    downloadMandate: config.jmw + config.jmw_market_env + config.jmw_market + "mutualfund/getMandateToDownload",
    mandateSwitch: config.jmw + config.jmw_mf + "sip/mandates",
};
